import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '@/layout/home'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login'),
  },
  {
    path: '/',
    component: home,
    redirect: '/user',
    children: [
      {
        path: 'user',
        name: 'user',
        component: () => import('@/views/user'),
      },
      {
        path: 'account',
        name: 'account',
        component: () => import('@/views/account'),
        redirect: '/account/admin',
        children: [
          {
            path: 'admin',
            name: 'admin',
            component: () => import('@/views/account/admin'),
          },
          {
            path: 'role',
            name: 'role',
            component: () => import('@/views/account/role'),
          },
          {
            path: 'menu',
            name: 'menu',
            component: () => import('@/views/account/menu'),
          },
        ],
      },
      {
        path: 'applet',
        name: 'applet',
        component: () => import('@/views/applet'),
      },
    ],
  },
  {
    path: '*',
    redirect: '/',
  },
]

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 }
  },
})

export default router
